<template>
  <hr v-if="separator" class="dropdown-divider">
  <a v-else-if="!custom && !hasLink" class="dropdown-item anchor" :class="anchorClasses" :role="ariaRoleItem" tabindex="0" href="javascript: void(0)" @click.stop.prevent="selectItem">
    <slot />
  </a>
  <div v-else :class="itemClasses" :role="ariaRoleItem" tabindex="0" @click.stop.prevent="selectItem">
    <slot />
  </div>
</template>

<script>
import { computed, inject } from 'vue';

export default {
  name: 'DDropdownItem',
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function],
      default: null,
    },
    color: {
      type: String,
      default: 'text-primary',
    },
    separator: Boolean,
    disabled: Boolean,
    custom: Boolean,
    paddingless: Boolean,
    hasLink: Boolean,
    ariaRole: {
      type: String,
      default: 'listitem',
      validator: (value) => [null, 'menuitem', 'listitem'].includes(value),
    },
  },

  emits: ['click'],
  
  setup(props, { emit }) {
    const dropdown = inject('dropdown', null);
    
    if (!dropdown) {
      throw new Error('You should wrap DDropdownItem in a DDropdown');
    }
    
    const anchorClasses = computed(() => [
      [`anchor-color--${props.color}`], {
        'is-disabled': dropdown.disabled || props.disabled,
        'is-paddingless': props.paddingless,
        'is-active': props.value !== null && props.value === dropdown.selected.value,
      }
    ]);

    const itemClasses = computed(() => ({
      'dropdown-item': !props.hasLink,
      'is-disabled': props.disabled,
      'is-paddingless': props.paddingless,
      'is-active': props.value !== null && props.value === dropdown.selected.value,
      'has-link': props.hasLink,
    }));

    const ariaRoleItem = computed(() => {
      return props.ariaRole === 'menuitem' || props.ariaRole === 'listitem' ? props.ariaRole : null;
    });

    const isClickable = computed(() => {
      return !dropdown.disabled && !props.separator && !props.disabled && !props.custom;
    });

    const selectItem = () => {
      if (!isClickable.value) return;
      dropdown.selectItem(props.value);
      emit('click');
    };

    return {
      anchorClasses,
      itemClasses,
      ariaRoleItem,
      isClickable,
      selectItem
    };
  }
};
</script>